import { initializeApp } from 'firebase/app';
import { getMessaging as fbGetMessaging, Messaging } from 'firebase/messaging';
import { MESSAGE_TYPES } from 'types/constants';

const firebaseConfig = process.env.FIREBASE_CONFIG ? JSON.parse(process.env.FIREBASE_CONFIG) : null;

if (!firebaseConfig) {
  console.error('Error: FIREBASE_CONFIG not loaded!');
}

const app = initializeApp(firebaseConfig);

const isIOS = () => {
  if (typeof window === 'undefined') return;

  return (
    /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
  );
};

const messaging: Messaging | null = (() => {
  if (typeof window == 'undefined' || isIOS()) return null;
  return fbGetMessaging(app);
})();

if (!isIOS() && typeof window !== 'undefined' && 'serviceWorker' in navigator) {
  navigator.serviceWorker
    .register('/firebase-messaging-sw.js')
    .then(() => {
      return navigator.serviceWorker.ready;
    })
    .then((registration) => {
      console.log('Service Worker ready:', registration);
      registration.active?.postMessage({
        type: MESSAGE_TYPES.INIT_FIREBASE,
        config: firebaseConfig,
      });
    })
    .catch((err) => console.error('Service Worker registration error:', err));
}

export { app, messaging };
